import { render, staticRenderFns } from "./AssistHistoryCard.vue?vue&type=template&id=15ae7b7a&scoped=true"
import script from "./AssistHistoryCard.vue?vue&type=script&lang=ts"
export * from "./AssistHistoryCard.vue?vue&type=script&lang=ts"
import style0 from "./AssistHistoryCard.vue?vue&type=style&index=0&id=15ae7b7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ae7b7a",
  null
  
)

export default component.exports